import QuantityPicker from '@common/components/QuantityPicker';
import { ToggleExtra } from '@common/components/Extras/controls';
import { GuestSelectorComponentProps } from '@common/components/Extras/controls/sharedTypes';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import {
  ButtonWrapper,
  ToggleExtraButton,
} from '@features/RoomRateConfigurationWizard/FormSteps/ExtrasStep/Extras/PerStay/PerStay.styles';
import { RoomRateFormValues } from '../../../RoomRateForm.schema';

const extrasField = (id: number, field: string) =>
  `extras.${id}.${field}` as FieldPath<RoomRateFormValues>;

type PerStayProps = {
  id: number;
  maxQuantity: number | null;
};

export const PerStay = ({ id, maxQuantity }: PerStayProps) => {
  const { control } = useFormContext<RoomRateFormValues>();

  return (
    <ButtonWrapper>
      {!!maxQuantity && (
        <Controller
          control={control}
          name={extrasField(id, 'quantity')}
          render={({ field: { value, onChange } }) => (
            <QuantityPicker
              input={{ value: (value as number) ?? 1, onChange }}
              maxValue={maxQuantity}
            />
          )}
        />
      )}
      <ToggleExtraButton>
        <Controller
          control={control}
          name={extrasField(id, 'isSelected')}
          render={({ field: { value, onChange } }) => (
            <ToggleExtra
              input={{
                value: value as boolean,
                onChange: onChange as GuestSelectorComponentProps['input']['onChange'],
              }}
            />
          )}
        />
      </ToggleExtraButton>
    </ButtonWrapper>
  );
};
